import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import type { RootState } from '../redux/store';
import { ContainerState } from './types';

const initialState: ContainerState = {
  sidebarShow: 'responsive',
  isLoading: false
};

export const containerSlice = createSlice({
  name: 'container',
  initialState,
  reducers: {
    setSidebarShow(
      state,
      action: PayloadAction<{ type: string; value: string | boolean }>
    ) {
      switch (action.payload.type) {
        case 'set':
          state.sidebarShow = action.payload.value;
          return;
        default:
          return;
      }
    },
    setIsLoading(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    }
  }
});

export const { setSidebarShow, setIsLoading } = containerSlice.actions;

export const containerState = (state: RootState) => state.container;

export const containerReducer = containerSlice.reducer;
